import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import '../../Components/Company.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BASE_URL, paybridge_Url } from '../../Config';

const CurrentDayRecord = () => {
  const [data, setData] = useState({
    userId: "",
    name: "",
  });

  const [summaryData, setSummaryData] = useState({
    total_payments: 0,
    completed_count: 0,
    pending_count: 0,
    failed_count: 0,
  });

  const [profileId, setProfileId] = useState("");

  // Fetch dashboard info (company/user)
  const fetchDashboardData = async (companyProfileId) => {
    try {
      const response = await axios.get(`${BASE_URL}Company_Dashboard?CompanyId=${companyProfileId}`);
      if (response.data) {
        setData({
          userId: response.data.userId,
          name: response.data.companyName || "Company",
        });
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Failed to fetch dashboard data.", "error");
    }
  };

  // Fetch summary data from new API
  const fetchSummaryData = async (companyProfileId) => {
    try {
      if (!companyProfileId) return;

      const payload = {
        companyId: companyProfileId,
        type: "currentDay",
      };

      const response = await axios.post(`${paybridge_Url}report/company/summary`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      if (response.data.success) {
        setSummaryData(response.data.data);
      } else {
        Swal.fire("Error", "No summary data returned from API", "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Failed to fetch summary data.", "error");
    }
  };

  // Load data on mount
  useEffect(() => {
    const storedUserData = sessionStorage.getItem("user");
    if (!storedUserData) {
      Swal.fire("Error", "No user data found in sessionStorage.", "error");
      return;
    }

    const userData = JSON.parse(storedUserData);
    const companyProfileId = userData.userId || userData.companyProfileId;
    setProfileId(companyProfileId);

    if (companyProfileId) {
      fetchDashboardData(companyProfileId);
      fetchSummaryData(companyProfileId);
    }
  }, []);

  // Refresh button
  const handleRefresh = () => {
    if (profileId) fetchSummaryData(profileId);
  };

  return (
    <div className="m-5">
      <div className="card">
        <div className="card-header text-center">
          <h4><b>{data.name || "Company"}</b> - Current Day Summary</h4>
          <button className="btn btn-outline-success mt-2" onClick={handleRefresh}>🔄 Refresh Data</button>
        </div>

        <div className="card-body">
          <div className="row">
            <InfoCard title="Total Payments" value={summaryData.total_payments} />
            <InfoCard title="Completed" value={summaryData.completed_count} />
            <InfoCard title="Pending" value={summaryData.pending_count} />
            <InfoCard title="Failed" value={summaryData.failed_count} />
          </div>
        </div>
      </div>
    </div>
  );
};

// Reusable card component
const InfoCard = ({ title, value }) => (
  <div className="col-3 mb-3">
    <div className="card text-center">
      <div className="card-header">{title}</div>
      <div className="card-body">
        <h4>{value}</h4>
      </div>
    </div>
  </div>
);

export default CurrentDayRecord;